import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@getgo/chameleon-web/react';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './index.module.scss';
const ShowMoreContent = ({ children }) => {
    const { t } = useTranslation();
    const bodyRef = useRef(null);
    const [showHasMore, setShowHasMore] = useState(false);
    const [isShowMoreClicked, setIsShowMoreClicked] = useState(false);
    useEffect(() => {
        const handleSetShowMore = () => {
            const hasShowMore = bodyRef.current.offsetHeight < bodyRef.current.scrollHeight;
            setShowHasMore(hasShowMore);
            setIsShowMoreClicked(false);
        };
        handleSetShowMore();
        window.addEventListener('resize', handleSetShowMore);
        return () => {
            window.removeEventListener('resize', handleSetShowMore);
        };
    }, []);
    const handleToggleShowMore = () => {
        setIsShowMoreClicked(!isShowMoreClicked);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: classNames(classes.showMoreContainer, isShowMoreClicked && classes.isShowMoreClicked), ref: bodyRef }, { children: children }), void 0), showHasMore && (_jsx(Link, Object.assign({ onClick: handleToggleShowMore, className: classes.showMoreLink }, { children: isShowMoreClicked ? t('show less') : t('show more') }), void 0))] }, void 0));
};
export default ShowMoreContent;
//# sourceMappingURL=index.js.map